import axios from "axios";

// Listar alterações com filtros e paginação
export const fetchAlteracoes = async (
  page: number = 1,
  perPage: number = 10,
  searchTerm: string = "",
  userTypeFilter: string = "",
  campoEditado: string = "",
) => {
  try {
    const token = sessionStorage.getItem("token");

    const apiUrl = `${process.env.REACT_APP_API_URL}/alteracoes`;
    const response = await axios.get(apiUrl, {
      params: { page, perPage, searchTerm, userTypeFilter, campoEditado },
      headers: { Authorization: `Bearer ${token}` },
    });
    return response.data;
  } catch (error) {
    console.error("Erro ao buscar alterações:", error);
    return { data: [], total: 0 };
  }
};

// Contar total de alterações
export const countAlteracoes = async () => {
  try {
    const token = sessionStorage.getItem("token");
    const apiUrl = `${process.env.REACT_APP_API_URL}/alteracoes/count`;
    const response = await axios.get(apiUrl, {
      headers: { Authorization: `Bearer ${token}` },
    });
    return response.data.total_alteracoes;
  } catch (error) {
    console.error("Erro ao contar alterações:", error);
    return 0;
  }
};

// Registrar nova alteração
export const registrarAlteracao = async (
  tabelaEditada: string,
  campoEditado: string,
  valorAntigo: string | null,
  valorNovo: string | null,
) => {
  try {
    const token = sessionStorage.getItem("token");
    const apiUrl = `${process.env.REACT_APP_API_URL}/alteracoes`;
    console.log({ tabelaEditada, campoEditado, valorAntigo, valorNovo });
    await axios.post(
      apiUrl,
      {
        tabela_editada: tabelaEditada,
        campo_editado: campoEditado,
        valor_antigo: valorAntigo,
        valor_novo: valorNovo,
      },
      {
        headers: { Authorization: `Bearer ${token}` },
      },
    );
  } catch (error) {
    console.error("Erro ao registrar alteração:", error);
  }
};
